import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import BannerOne from '../BannerOne/BannerOne';

const MainCarrousel = () => {
  const sliderSettings = {
    dots: false,
    infinite: true,
    autoplay: false,
    speed: 500,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 0,
    initialSlide: 0,
    draggable: false
  };

  return (
    <div className="MainCarrousel">
      <Slider {...sliderSettings}>
        <div>
          <BannerOne />
        </div>
        <div>
          <BannerOne />
        </div>
      </Slider>
    </div>
  );
};

export default MainCarrousel;
